export const DataForReviewWriting = function () {
    this.selfReviewTemplate    = {groups: []};
    this.peerReviewTemplate    = {groups: []};
    this.managerReviewTemplate = {groups: []};
    this.reviewProcessStages   = [];
    this.reviewProcessType     = '';
};